var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 15.4183C7.948 15.4183 7.5 14.9419 7.5 14.355C7.5 13.7681 7.948 13.2917 8.5 13.2917C9.052 13.2917 9.5 13.7681 9.5 14.355C9.5 14.9419 9.052 15.4183 8.5 15.4183ZM8.5 11.1651C6.846 11.1651 5.5 12.5963 5.5 14.355C5.5 16.1137 6.846 17.5449 8.5 17.5449C10.154 17.5449 11.5 16.1137 11.5 14.355C11.5 12.5963 10.154 11.1651 8.5 11.1651ZM14.5 18.6082C14.5 19.1951 14.052 19.6715 13.5 19.6715H3.5C2.948 19.6715 2.5 19.1951 2.5 18.6082V10.1018C2.5 9.51491 2.948 9.03856 3.5 9.03856H4.5H6.5H10.5H12.5H13.5C14.052 9.03856 14.5 9.51491 14.5 10.1018V18.6082ZM6.5 4.90342C6.5 3.66575 7.397 2.65881 8.5 2.65881C9.603 2.65881 10.5 3.66575 10.5 4.90342V6.91197H6.5V4.90342ZM13.5 6.91197H12.5V4.90342C12.5 2.494 10.706 0.532227 8.5 0.532227C6.294 0.532227 4.5 2.494 4.5 4.90342V6.91197H3.5C1.846 6.91197 0.5 8.34316 0.5 10.1018V18.6082C0.5 20.3669 1.846 21.798 3.5 21.798H13.5C15.154 21.798 16.5 20.3669 16.5 18.6082V10.1018C16.5 8.34316 15.154 6.91197 13.5 6.91197Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.b3a4e8408e9e29f2bad4dbad39cbdd70.svg";
export { ForwardRef as ReactComponent };